export default [
	{
		title: 'Survey Details',
		subTitle: 'Text Message & Carrot',
		content: [
			'What do you want to say in the message?',
			'Delay Days - How many days since the customer checked in till you want to send them the survey?',
			'Days Between - the time between surveys; customers will not receive this survey again for this number of days'
		]
	},
	{
		title: 'Who Gets it',
		subTitle: 'Who to send this to?',
		content: [
			'Send to all your customers',
			'or',
			'Selecting individual locations will send this campaign to only the customers of the selected locations.'
		]
	},
	{
		title: 'The Offer',
		subTitle: 'The Carrot',
		content: [
			'Name the offer for you and your team.',
			'Customer display is shown on the tablet and online when the customer views this offer.',
			'Cashier directions is shown on the tablet to the cashiers to direct them how to redeem this offer for the customer.',
			'How many days after receiving this offer do you want it to expire?'
		]
	},
	{
		title: 'Survey Questions',
		subTitle: '',
		content: [
			`Add survey questions. Click the plus on the left to add a new question.
			Type the question you'd like ask, if the question already exists select it, otherwise finish typing and hit enter.
			Finally select the answer type.
			For additional quesitons repeat this process.`
		]
	},
	{
		title: 'Survey Confirmation',
		subTitle: '',
		content: 'Please confirm the details of this survey'
	},
]



/** WEBPACK FOOTER **
 ** ./src/helpers/SurveyInfo.js
 **/